<script>
  import TaskReportItem from './TaskReportItem.svelte';
  import { Modal } from 'bootstrap';
  import Loader from '../../components/Loader.svelte';
  import InfiniteScroll from 'components/DataTable/InfiniteScroll.svelte';
  import { mergeNotificationArr } from 'components/Helper.js';
  import { client } from 'root/api/index.js';
  import { onMount, getContext } from 'svelte';
  import { navigate } from 'svelte-routing';
  export let handleClick = (e) => {};
  const showDialog = getContext('showDialog');
  let addTaskReportModal;
  let itemName = '';
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let reportData = [];
  let isPaginationLoading = false;
  let isAjaxSent = false;
  const getReportList = () => {
    isPaginationLoading = true;
    client
      .taskTemplateReportList(pageSize, pageNumber, { ...extraFilter })
      .then((response) => {
        isPaginationLoading = false;
        reportData = mergeNotificationArr(reportData, response.data.payload);
        totalPages = response.data.pagination.totalPage;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };

  onMount(() => {
    addTaskReportModal = new Modal(document.getElementById('taskReportModal'), {
      keyboard: false,
    });
  });
  export const showModal = (id, name) => {
    isAjaxSent = true;
    itemName = name;
    extraFilter.id = id;
    addTaskReportModal.show();
  };
  let defaultFilter = {
    id: '',
  };
  let extraFilter = { ...defaultFilter };
  const filterData = () => {
    if (isAjaxSent) {
      pageNumber = 1;
      totalPages = 0;
      reportData = [];
      getReportList();
    }
  };
  $: extraFilter && filterData();
</script>

<div
  class="modal fade slide-modal"
  id="taskReportModal"
  tabindex="-1"
  aria-labelledby="taskReportModal"
  aria-hidden="true"
>
  <div class="modal-dialog add-task-modal h-100 m-0 float-end">
    <div class="modal-content">
      <div class="d-flex flex-column h-100">
        <div class="modal-header rounded-0">
          <h5 class="modal-title font-size-14 text-break">
            Task: {itemName}
          </h5>
          <button
            on:click={() => {
              handleClick();
            }}
            type="button"
            class="close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" />
          </button>
        </div>
        <div class="page-content p-3">
          {#if reportData.length <= 0 && !isPaginationLoading}
            <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
              <svg
                width="40"
                height="40"
                viewBox="0 0 100 100"
                fill="#787e8d"
                ><path
                  d="M6.25 53.125V37.5H0V6.25H81.25V37.5H21.875L6.25 53.125ZM6.25 31.25H12.5V38.0371L19.2871 31.25H75V12.5H6.25V31.25ZM100 50V81.25H93.75V96.875L78.125 81.25H18.75V50H100ZM93.75 56.25H25V75H80.7129L87.5 81.7871V75H93.75V56.25Z"
                  fill=""
                ></path></svg
              >
              <span class="color-lead font-size-18 mt-3 d-block"
                >You don't have any client log yet</span
              >
            </div>
          {/if}

          {#each reportData as item, itemkey}
            <div class="mb-3">
              <div
                class="d-flex flex-row justify-content-between task-details-header mb-2 align-items-center"
              >
                <span class="font-size-18">{item.label}</span>
                <div class="due-date-heading text-center">
                  <span class="text-muted font-size-12">Due Date</span>
                </div>
              </div>
              {#each item.values as itemData, itemdatakey}
                <TaskReportItem
                  company={itemData.name}
                  recurring={itemData.recurring}
                  id={itemData.id}
                  date={itemData.dueDate}
                />
              {/each}
            </div>
          {/each}
          <InfiniteScroll
            threshold={300}
            hasMore={pageNumber < totalPages}
            isLoading={isPaginationLoading}
            on:loadMore={() => {
              pageNumber = pageNumber + 1;
              getReportList();
            }}
          >
            <div class="scroll-spinner-container d-flex justify-content-center align-items-center">
              <Loader Style="loader-block" />
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  </div>
</div>
